// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"3093":"e6a18dfcfb3424cafd0f","3180":"a7ec085aef70d77a919f","9277":"ff727f26f70fda5cc01c"}[chunkId] + ".css";
};